import Vue from 'vue'
import Router from 'vue-router'
import Application from '@/components/Application'
import Login from '@/components/Login'
import VerifyAccount from '@/components/VerifyAccount'
import ApplicationList from '@/components/ApplicationList'
import AppAdminView from '@/components/admin/AppAdminView'
import SubmittedApplication from '@/components/SubmittedApplication'
import LoginError from '@/components/LoginError'
import Contact from '@/components/Contact'
import Register from '@/components/Register'
import PasswordReset from '@/components/PasswordReset'
import PageLenderSelectionWizard from '@/components/PageLenderSelectionWizard.vue'
import PageLenderUseOfTerms from '@/components/PageLenderUseOfTerms.vue'

// Register the router
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'loginRoot',
      component: Login,
      meta: { loginRequired: false }
    },
    {
      path: '/login/:loginToken?',
      name: 'login',
      component: Login,
      meta: { loginRequired: false }
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
      meta: { loginRequired: false }
    },
    {
      path: '/passwordReset',
      name: 'passwordReset',
      component: PasswordReset,
      meta: { loginRequired: false }
    },
    {
      path: '/submittedApplication',
      name: 'submittedApplication',
      component: SubmittedApplication,
      meta: { loginRequired: true },
      props: true
    },
    {
      path: '/lender-use-of-terms',
      name: 'lender-use-of-terms',
      component: PageLenderUseOfTerms,
      meta: { loginRequired: true },
      props: true
    },
    {
      path: '/lender-selection',
      name: 'lender-selection',
      component: PageLenderSelectionWizard,
      meta: { loginRequired: true }
    },
    {
      path: '/application',
      name: 'application',
      component: Application,
      meta: { loginRequired: true },
      props: true
    },
    {
      path: '/applicationList',
      name: 'applicationList',
      component: ApplicationList,
      meta: { loginRequired: true }
    },
    {
      path: '/applicationAdminList',
      name: 'applicationAdminList',
      component: AppAdminView,
      meta: { loginRequired: true }
    },
    {
      path: '/loginError',
      name: 'loginError',
      component: LoginError,
      meta: { loginRequired: false }
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact,
      meta: { loginRequired: true }
    },
    {
      path: '/:token',
      name: 'verifyAccount',
      component: VerifyAccount,
      meta: { loginRequired: false }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/router.js